<ng-container *ngIf="{ rtlDir: rtlDir$ | async } as vm">
  <p-drawer
    #sidebar
    [(visible)]="configActive"
    [position]="vm.rtlDir ? 'left' : 'right'"
    [blockScroll]="true"
    [showCloseIcon]="false"
    [baseZIndex]="1000"
    styleClass="layout-config app-config !p-0"
    (onHide)="cancel()"
  >
    <ng-container [ngTemplateOutlet]="sidebarTpl"></ng-container>
  </p-drawer>

  <p-button
    type="button"
    (onClick)="toggleConfigMenu()"
    [icon]="!configActive ? 'pi pi-cog' : 'pi pi-times'"
    [styleClass]="
      'layout-config-button ' +
      (configActive ? (vm.rtlDir ? 'active--rtl' : 'active') : '')
    "
    ariaLabel="theme config"
    data-testid="close-config"
  ></p-button>

  <ng-template #themeScale>
    <div class="flex items-center">
      <p-button
        type="button"
        icon="pi pi-minus"
        (onClick)="decrementScale()"
        styleClass="p-button-rounded p-button-text p-button-plain mr-4 animate-flip"
        [disabled]="fontScale === fontScales[0]"
        data-testid="decrement-font-scale"
      >
      </p-button>

      <span
        class="m-1 scale-icon"
        *ngFor="let s of fontScales"
        [ngClass]="{ 'scale-active': s === fontScale }"
      >
      </span>
      <p-button
        type="button"
        icon="pi pi-plus"
        (onClick)="incrementScale()"
        styleClass="p-button-rounded p-button-text ml-4 p-button-plain animate-flip"
        [disabled]="fontScale === fontScales[fontScales.length - 1]"
        data-testid="increment-font-scale"
      ></p-button>
    </div>
  </ng-template>
  <ng-template #layoutModeTpl>
    <div class="flex items-center mt-1">
      <div class="flex items-center mr-2 animate-flip">
        <p-radioButton
          name="layoutMode"
          value="light"
          [(ngModel)]="layoutMode"
          inputId="layoutMode1"
          (onClick)="onLayoutModeChange($event, 'light')"
          data-testid="layout-mode-light"
        ></p-radioButton>
        <label for="layoutMode1" class="ml-2 animate-flip">{{
          "labels.LayoutLight" | translate
        }}</label>
      </div>

      <div class="flex items-center mr-4 animate-flip">
        <p-radioButton
          name="layoutMode"
          value="dark"
          [(ngModel)]="layoutMode"
          inputId="layoutMode2"
          (onClick)="onLayoutModeChange($event, 'dark')"
          data-testid="layout-mode-dark"
        ></p-radioButton>
        <label for="layoutMode2" class="ml-2 animate-flip">{{
          "labels.LayoutDark" | translate
        }}</label>
      </div>
    </div>
  </ng-template>
  <ng-template #menuModeTpl>
    <div class="flex flex-wrap">
      <ng-container
        *ngFor="let mode of menuModes; index as i; trackBy: trackByFn"
      >
        <div class="flex items-center mr-4 mt-1">
          <p-radioButton
            name="menuMode"
            [value]="mode.value"
            [ngModel]="menuMode"
            (ngModelChange)="onChangeMenuMode($event)"
            inputId="menuMode-{{ i }}"
            [attr.data-testid]="'menu-mode-' + i"
          ></p-radioButton>
          <label class="mx-2" for="menuMode-{{ i }}">{{
            "labels." + mode.text | translate
          }}</label>
        </div>
      </ng-container>
    </div>
  </ng-template>

  <ng-template #sidebarTpl>
    <div
      appHelpButtonPositioner
      class="layout-config-panel flex flex-col px-4 p-lg:col-4"
      [attr.aria-label]="'labels.Theme_Customization' | translate"
    >
      <div class="theme-header">
        <div class="flex justify-between">
          <h5 class="mt-4 color-3e">
            {{ "labels.QUICK_SETTINGS" | translate }}
          </h5>
          <div class="mt-2">
            <p-button
              styleClass="p-button-text  w-100 !pl-8 !pr-8"
              [label]="'action.RESET' | translate"
              icon="pi pi-refresh"
              [attr.area-label]="'base.actions.cancel' | translate"
              (onClick)="resetToDefault()"
              data-testid="reset-to-default-setting"
            ></p-button>
          </div>
        </div>
        <hr class="m-0 p-0" />
        <h5 class="mt-4 color-3e">
          {{ "label.DISPLAY_SETTINGS" | translate }}
        </h5>
      </div>
      <div class="input-square-group">
        <app-form-field>
          <app-form-label>
            {{ "labels.THEME" | translate }}
          </app-form-label>
          <app-select
            styleClass="border w-100"
            bindLabel="theme_name"
            bindKey="id"
            [options]="themes$ | async"
            [(ngModel)]="themeName"
            (ngModelChange)="
              layoutMode = !!themeName?.dark_mode ? 'dark' : 'light';
              onLayoutModeChange($event, layoutMode)
            "
            [filter]="false"
            data-testid="select-theme"
          >
          </app-select>
        </app-form-field>
      </div>
      <div class="py-2">
        <h6 class="color-3e mt-0 mb-0">
          {{ "labels.ThemeScale" | translate }}
        </h6>
        <ng-container [ngTemplateOutlet]="themeScale"></ng-container>
        <h6 class="color-3e mt-0 mb-0">
          {{ "labels.LayoutMode" | translate }}
        </h6>
        <ng-container [ngTemplateOutlet]="layoutModeTpl"></ng-container>
      </div>
      <div class="py-2">
        <h6 class="color-3e mt-0 mb-0">
          {{ "labels.MenuMode" | translate }}
        </h6>
        <ng-container [ngTemplateOutlet]="menuModeTpl"></ng-container>
      </div>
      <div>
        <h5 class="color-3e mt-0 mb-0">
          {{ "labels.RegionalSetting" | translate }}
        </h5>
        <div class="input-square-group mt-4">
          <app-form-field>
            <app-form-label>
              {{ "labels.LANGUAGE" | translate }}
            </app-form-label>
            <app-select
              styleClass=" w-100 border"
              appendTo="body"
              [options]="languages$ | async"
              bindLabel="name"
              bindIcon="flag"
              [(ngModel)]="language"
              [filter]="false"
              data-testid="select-language"
            >
            </app-select>
          </app-form-field>
        </div>
        <div class="input-square-group mt-4">
          <app-form-field>
            <app-form-label>
              {{ "labels.TIMEZONE" | translate }}
            </app-form-label>
            <app-select
              styleClass=" w-100 border"
              appendTo="body"
              [options]="timeZones$ | async"
              bindLabel="time_zone"
              [(ngModel)]="timeZone"
              [filter]="false"
              data-testid="select-timezone"
            >
            </app-select>
          </app-form-field>
        </div>
        <div class="input-square-group mt-4">
          <app-form-field>
            <app-form-label>
              {{ "labels.DATE_FORMAT" | translate }}
            </app-form-label>
            <app-select
              styleClass=" w-100 border"
              appendTo="body"
              [options]="dates$ | async"
              bindLabel="value"
              [(ngModel)]="dateFormat"
              [filter]="false"
              data-testid="select-date-format"
            >
            </app-select>
          </app-form-field>
        </div>
        <div class="input-square-group mt-4">
          <app-form-field>
            <app-form-label>
              {{ "labels.TIME_FORMAT" | translate }}
            </app-form-label>
            <app-select
              styleClass=" w-100 border"
              appendTo="body"
              [options]="times$ | async"
              bindLabel="value"
              [(ngModel)]="timeFormat"
              [filter]="false"
              data-testid="select-time-format"
            >
            </app-select>
          </app-form-field>
        </div>
        <div class="input-square-group mt-4">
          <app-form-field>
            <app-form-label>
              {{ "labels.DATE_TIME_FORMAT" | translate }}
            </app-form-label>
            <app-select
              styleClass=" w-100 border"
              appendTo="body"
              [options]="dateTimes$ | async"
              bindLabel="value"
              [filter]="false"
              [(ngModel)]="dateTime"
              data-testid="select-date-time-format"
            >
            </app-select>
          </app-form-field>
        </div>
        <!-- <ng-container [ngTemplateOutlet]="language"></ng-container> -->
      </div>
      <div class="flex justify-between mt-2 mb-8">
        <p-button
          styleClass="p-button-outlined  w-100 !pl-8 !pr-8"
          [label]="'base.actions.cancel' | translate"
          [attr.area-label]="'base.actions.cancel' | translate"
          (onClick)="cancel()"
          data-testid="cancel-setting"
        ></p-button>
        <app-split-button
          *ngIf="!isAnonymous"
          icon="pi pi-save"
          [label]="'base.actions.savePerAccount' | translate"
          [model]="configurationActions"
          (onClick)="savePerAccount()"
          data-testid="save-per-account"
        ></app-split-button>
        <p-button
          *ngIf="isAnonymous"
          icon="pi pi-save"
          styleClass=" w-100 !pl-8 !pr-8"
          [label]="'base.actions.savePerSession' | translate"
          [attr.area-label]="'base.actions.savePerSession' | translate"
          (onClick)="saveConfigurationInSessionStorage()"
          data-testid="0-save-per-session"
        ></p-button>
      </div>
      <div class="flex flex-row mt-8">
        <div class="text-info op-7">
          <p
            class="mb-0"
            [innerHtml]="'labels.Copyright' | translate: { date: currentYear }"
          ></p>
          <span
            >{{ "label.VERSION" | translate }} {{ webVersion$ | async }} /
            {{ backendVersion$ | async }}</span
          >
        </div>
      </div>
    </div>
  </ng-template>
</ng-container>
